var map = {
	"./adder.png": 1525,
	"./and.png": 8188,
	"./buffer.png": 2889,
	"./decoder.png": 5096,
	"./divider.png": 7584,
	"./inverter.png": 8271,
	"./multiplexer.png": 7335,
	"./multiplier.png": 1758,
	"./nand.png": 5969,
	"./nor.png": 7204,
	"./or.png": 8219,
	"./subtractor.png": 9193,
	"./xor.png": 2232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;